// extracted by mini-css-extract-plugin
export default {"melodyVideo":"SK-z","isFullWidth":"TK-z","landingPageVideo":"UK-z","play":"VK-z","iframeVideo":"WK-z","playHidden":"XK-z","fullwidth":"YK-z"};